import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProdutoInclusoComponent } from 'src/app/components/produto/produto-incluso/produto-incluso.component';

@NgModule({
  declarations: [
    ProdutoInclusoComponent
  ],
  exports: [
    ProdutoInclusoComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ProdutoInclusoModule { }
